module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "handsontable"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7cac9f26!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-handsontable/src/Handsontable.vue
// module id = 314
// module chunks = 2